/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DisplaySiteSelect_DisplayFragment = { __typename: 'Display', id: string, site?: { __typename: 'Site', id: string, name: string, address?: string | null } | null };

export type DisplaySiteSelect_CustomerFragment = { __typename: 'Customer', id: string, sites: Array<{ __typename: 'Site', id: string, name: string, address?: string | null }> };

export type UpdateDisplaySiteMutationVariables = Types.Exact<{
  input: Types.DisplayUpdateSiteInput;
}>;


export type UpdateDisplaySiteMutation = { __typename: 'Mutation', displayUpdateSite: { __typename: 'Display', id: string, site?: { __typename: 'Site', id: string, name: string, address?: string | null } | null } };

export const DisplaySiteSelect_DisplayFragmentDoc = gql`
    fragment DisplaySiteSelect_display on Display {
  id
  site {
    id
    name
    address
  }
}
    `;
export const DisplaySiteSelect_CustomerFragmentDoc = gql`
    fragment DisplaySiteSelect_customer on Customer {
  id
  sites {
    id
    name
    address
  }
}
    `;
export const UpdateDisplaySiteDocument = gql`
    mutation UpdateDisplaySite($input: DisplayUpdateSiteInput!) {
  displayUpdateSite(input: $input) {
    id
    site {
      id
      name
      address
    }
  }
}
    `;
export type UpdateDisplaySiteMutationFn = ApolloReactCommon.MutationFunction<UpdateDisplaySiteMutation, UpdateDisplaySiteMutationVariables>;

/**
 * __useUpdateDisplaySiteMutation__
 *
 * To run a mutation, you first call `useUpdateDisplaySiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisplaySiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisplaySiteMutation, { data, loading, error }] = useUpdateDisplaySiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisplaySiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDisplaySiteMutation, UpdateDisplaySiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDisplaySiteMutation, UpdateDisplaySiteMutationVariables>(UpdateDisplaySiteDocument, options);
      }
export type UpdateDisplaySiteMutationHookResult = ReturnType<typeof useUpdateDisplaySiteMutation>;
export type UpdateDisplaySiteMutationResult = ApolloReactCommon.MutationResult<UpdateDisplaySiteMutation>;
export type UpdateDisplaySiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDisplaySiteMutation, UpdateDisplaySiteMutationVariables>;